import styled from 'styled-components'
import { prop } from 'styled-tools'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    background-color: #0F1A2A;
    padding: 70px 60px;
    display: flex;
    justify-content: center;

    @media (max-width: 1000px) {
        padding: 0 30px 40px 30px;
    }
`

export const ContainerInterno = styled.div`
    display: inline-block;
    max-width: 1436px;
`

export const TituloPrincipal = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    font-size: 26px;
    line-height: 36px;
    font-weight: 900;
    margin: 0 0 40px 0;
    text-align: center;

    strong {
        color: #EDC748;
    }

    @media (max-width: 768px) {
        font-size: 22px;
        line-height: 32px;
        margin: 0 0 40px 0;
    }
`

export const BoxBaixo = styled.div`
    float: left;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media only screen and (max-width: 1800px) {
        flex-direction: column;
    }
`

export const BoxBaixoCol6 = styled.div`
    float: left;
    width: 50%;

    @media only screen and (max-width: 1800px) {
        width: 100%;

        &.boxImagem {
            text-align: center;
        }
    }
`

export const ImagemPrincipal = styled.img`
    max-width: 100%;
`

export const ListaConteudos = styled.div`
    float: left;
    width: 100%;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;

    @media only screen and (max-width: 700px) {
        grid-template-columns: repeat(1, 1fr);
    }
`

export const ListaConteudosItem = styled.div`
    padding: 10px 30px;
    border: solid 1px ${ props => props.premium ? '#EDC748' : '#FFE58F' };
    border-radius: 11px;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    background: ${props => props.indexPlano === 1 ? '#EDC748' : 'none'};
`

export const ListaConteudosItemBoxTitulo = styled.div`
    float: left;
    width: 100%;
    display: flex;
    align-items: center;
`

export const ListaConteudosItemTitulo = styled.span`
    float: left;
    width: 100%;
    margin: 0;
    padding: 0;
    color: ${props => props.premium ? '#EDC748' : '#FFE58F'};
    font-weight: 600;
    flex: 1;

    &.ultimo {
        color: #0F1A2A;
    }
`

export const ListaConteudosItemImg = styled.img`
    width: 45px;
`

export const ListaConteudosItemListaBonus = styled.ul`
    float: left;
    width: 100%;
    margin: ${props => props.indexPlano === 1 ? '0' : '15px 0 0 0'};
    padding: 0;
`

export const ListaConteudosItemListaBonusItem = styled.li`
    list-style: none;
    color: #CBD4E1;
    font-size: 14px;
    line-height: 22px;

    &.premium {
        strong {
            color: #EDC748;
        }
    }

    .cor {
        color: #FFE58F;
    }

    &.ultimo {
        color: #0F1A2A;
        strong {
            color: #0F1A2A;
        }
    }

`

export const BoxDataFim = styled.div`
    float: left;
    width: 100%;
    margin-top: 60px;
    display: flex;
    justify-content: center;
`

export const BoxDataFimSpan = styled.span`
    background-color: #EDC748;
    color: #0F1A2A;
    font-weight: 900;
    font-size: 16px;
    padding: 15px 150px;
    letter-spacing: 0.5px;
    border-radius: 5px;

    @media only screen and (max-width: 768px) {
        padding: 15px;
        width: 100%;
        text-align: center;
        letter-spacing: 0;
    }
`